import {defineStore} from "pinia";
import {useStorage} from "@vueuse/core";
import {computed} from "vue";
import {useFetch} from "../composables/fetch";
import {AuthenticationResponse, User} from "../models/auth";
import {useUser} from "../composables/auth";


export const useUserStore = defineStore('user', () => {
    const token = useStorage('token', '')
    const user = useStorage<User>('user', {
        email: '',
        username: '',
        admin: false,
        anyAdmin: false
    })
    const loggedIn = computed(() => !!token.value)

    async function auth(login: string, password: string) {
        const {data} = await useFetch<AuthenticationResponse>('authentication/login')
            .post({
                login: login,
                password: password
            })
            .json()
        if (data?.value?.token) {
            token.value = data.value.token
            await fetchUser()
            return true
        }
        return false
    }

    async function fetchUser() {
        const {data} = await useUser()
        user.value = data.value
    }

    async function logout() {
        token.value = null
        user.value = null
        await this.router.push('/login')
    }

    return {token, loggedIn, auth, logout, user}
})